import { useEffect, useState } from "react";

/**
 * ReopenCountdown · v2.8+E305
 * ───────────────────────────
 * Live "reopens in 4h 41m" ticker. Renders nothing once the target passes
 * (parent's is_open will flip via usePortalHours' precise boundary timer) or
 * when no target is provided. Ticks every second; shows h/m, then m, then
 * seconds in the final minute.
 */
function fmt(ms) {
  if (ms <= 0) return null;
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return `${s}s`;
}

export default function ReopenCountdown({
  nextOpenAt,
  prefix = "reopens in ",
  className = "",
  testId = "reopen-countdown",
}) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, []);

  if (!nextOpenAt) return null;
  const target = new Date(nextOpenAt).getTime();
  if (Number.isNaN(target)) return null;
  const label = fmt(target - Date.now());
  if (!label) return null;

  return (
    <span className={className} data-testid={testId}>
      {prefix}{label}
    </span>
  );
}
